module.exports = __webpack_public_path__ + "img/btn_baoqie_ov.4ad135af.png";